export const BdeLabel = {
  BDE: "BDE",
  CompanyName: "Company Name",
  ClientName: "Client Name",
  EmployeeName: "Employee Name",
  AlisedName: "Aliased Name",
  YearOfExp: "Year's Of Experience",
  Technology: "Technology",
  DateOfInterview: "Date Of Interview",
  ScheduleBy: "Schedule By",
  Round: "Round",
  Remark: "Remark",
  UpdateBDE: "Update BDE",
  DeleteBDE: "Delete BDE",
  AddBDE: "Add BDE",
  BDEForm: "BDE Form",
  DeveloperName: "Developer Name",
  CompanyInformation: "Company Information",
  Client: "Client",
  Company: "Company",
  ClientDesignation: "Client Designation",
  ClientInformation: "Client Information",
  Email: "Email",
  PhoneNo: "Phone Number",
  AliasedUser: "Aliased User",
  AliasedUserName: "Aliased User Name",
  AddAliased: "Add Aliased",
  UpdateAliasedUser: "Update Aliased User",
  AddAliasedUser: "Add Aliased User",
};
